/* ==========================================================================
   DONIA STORE — theme behaviour (vanilla JS, no build step).
   Talks to Shopify's public AJAX Cart API + Predictive Search API directly.
   ========================================================================== */
(function () {
  "use strict";

  var moneyFormat = window.donia_settings && window.donia_settings.money_format
    ? window.donia_settings.money_format
    : "LE {{amount_no_decimals}}";

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return moneyFormat.replace(/\{\{\s*amount[_a-z]*\s*\}\}/g
, amount);
  }

  /* ---------------- Toasts ---------------- */
  function showToast(message, type) {
    var wrap = document.getElementById("donia-toast-wrap");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.id = "donia-toast-wrap";
      wrap.className = "donia-toast-wrap";
      document.body.appendChild(wrap);
    }
    var toast = document.createElement("div");
    toast.className = "donia-toast" + (type === "error" ? " donia-toast--error" : "");
    toast.textContent = message;
    wrap.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add("is-visible"); });
    setTimeout(function () {
      toast.classList.remove("is-visible");
      setTimeout(function () { toast.remove(); }, 300);
    }, 2200);
  }

  /* ---------------- Favorites (localStorage) ---------------- */
  var FAV_KEY = "donia_favorites";
  var RV_KEY = "donia_recently_viewed";

  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || "[]"); } catch (e) { return []; }
  }
  function setFavorites(list) {
    localStorage.setItem(FAV_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent("donia:favorites-changed", { detail: list }));
  }
  function toggleFavorite(handle) {
    var list = getFavorites();
    var idx = list.indexOf(handle);
    if (idx > -1) list.splice(idx, 1); else list.push(handle);
    setFavorites(list);
    return list.indexOf(handle) > -1;
  }
  function pushRecentlyViewed(handle) {
    var list = getFavorites ? (function () { try { return JSON.parse(localStorage.getItem(RV_KEY) || "[]"); } catch (e) { return []; } })() : [];
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, 8);
    localStorage.setItem(RV_KEY, JSON.stringify(list));
  }
  function getRecentlyViewed() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || "[]"); } catch (e) { return []; }
  }

  function updateFavoriteUI() {
    var favs = getFavorites();
    document.querySelectorAll("[data-favorite-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-favorite-toggle");
      btn.classList.toggle("is-active", favs.indexOf(handle) > -1);
    });
    document.querySelectorAll("[data-favorites-count]").forEach(function (el) {
      el.textContent = favs.length;
      el.hidden = favs.length === 0;
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-favorite-toggle]");
    if (!btn) return;
    e.preventDefault();
    toggleFavorite(btn.getAttribute("data-favorite-toggle"));
    updateFavoriteUI();
  });
  document.addEventListener("donia:favorites-changed", updateFavoriteUI);

  /* ---------------- Drawers (cart / search / mobile menu) ---------------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    var anyOpen = document.querySelector(".donia-drawer.is-open, .donia-mobile-menu.is-open");
    if (!anyOpen) document.body.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    var openTrigger = e.target.closest("[data-open-drawer]");
    if (openTrigger) {
      e.preventDefault();
      var target = document.getElementById(openTrigger.getAttribute("data-open-drawer"));
      openDrawer(target);
      if (target && target.id === "donia-cart-drawer") syncCartUI();
      if (target && target.id === "donia-search-drawer") {
        var input = target.querySelector("input[type=search]");
        if (input) setTimeout(function () { input.focus(); }, 150);
      }
    }
    var closeTrigger = e.target.closest("[data-close-drawer]");
    if (closeTrigger) {
      e.preventDefault();
      var wrap = closeTrigger.closest(".donia-drawer, .donia-mobile-menu");
      closeDrawer(wrap);
    }
    if (e.target.classList.contains("donia-drawer-overlay")) {
      closeDrawer(e.target.closest(".donia-drawer, .donia-mobile-menu"));
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll(".donia-drawer.is-open, .donia-mobile-menu.is-open").forEach(closeDrawer);
    }
  });

  /* ---------------- Cart (AJAX Cart API) ---------------- */
  function cartFetch(url, options) {
    options = options || {};
    options.headers = Object.assign({ "Content-Type": "application/json", Accept: "application/json" }, options.headers);
    return fetch(url, options).then(function (r) { return r.json(); });
  }

  function getCart() { return cartFetch("/cart.js"); }

  function addToCart(variantId, quantity) {
    return cartFetch("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    }).then(function () { return syncCartUI(); });
  }

  function changeCartLine(key, quantity) {
    return cartFetch("/cart/change.js", {
      method: "POST",
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function () { return syncCartUI(); });
  }

  function renderCartLine(item) {
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : "";
    return (
      '<li class="donia-cart-line" data-key="' + item.key + '">' +
      '<img src="' + img + '" alt="" loading="lazy" class="donia-cart-line-img" />' +
      '<div class="donia-cart-line-body">' +
      '<span class="donia-cart-line-title">' + item.product_title + "</span>" +
      '<span class="donia-cart-line-variant">' + (item.variant_title || "") + "</span>" +
      '<span class="donia-price-num donia-cart-line-price">' + formatMoney(item.final_price) + "</span>" +
      '<div class="donia-cart-line-actions">' +
      '<div class="donia-qty-picker">' +
      '<button type="button" data-cart-qty="' + item.key + '" data-delta="1" aria-label="+">+</button>' +
      '<span class="donia-price-num">' + item.quantity + "</span>" +
      '<button type="button" data-cart-qty="' + item.key + '" data-delta="-1" aria-label="-">-</button>' +
      "</div>" +
      '<button type="button" class="donia-cart-remove" data-cart-remove="' + item.key + '" aria-label="حذف">✕</button>' +
      "</div></div></li>"
    );
  }

  function syncCartUI() {
    return getCart().then(function (cart) {
      var countEls = document.querySelectorAll("[data-cart-count]");
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      var linesEl = document.getElementById("donia-cart-lines");
      var emptyEl = document.getElementById("donia-cart-empty");
      var footerEl = document.getElementById("donia-cart-footer");
      if (linesEl) {
        linesEl.innerHTML = cart.items.map(renderCartLine).join("");
      }
      if (emptyEl) emptyEl.hidden = cart.item_count > 0;
      if (footerEl) footerEl.hidden = cart.item_count === 0;
      var totalEl = document.getElementById("donia-cart-total");
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      var suggestList = document.getElementById("donia-cart-suggest");
      if (suggestList) {
        var inBag = cart.items.map(function (i) { return i.handle; });
        suggestList.querySelectorAll("[data-handle]").forEach(function (el) {
          el.hidden = inBag.indexOf(el.getAttribute("data-handle")) > -1;
        });
      }
      return cart;
    });
  }

  /* ---------------- Quick view modal (matches source's ProductCard dialog) ---------------- */
  function openQuickView(handle) {
    var modal = document.getElementById("donia-quickview-modal");
    var body = document.getElementById("donia-quickview-body");
    if (!modal || !body) return;
    body.innerHTML = '<p class="donia-loading-text">جارِ التحميل…</p>';
    openDrawer(modal);
    fetch("/products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (product) { renderQuickView(product, body); })
      .catch(function () { body.innerHTML = '<p class="donia-loading-text">تعذّر تحميل المنتج.</p>'; });
  }

  function renderQuickView(product, body) {
    var colorOptIndex = -1, sizeOptIndex = -1;
    (product.options || []).forEach(function (name, i) {
      if (/color|لون/i.test(name)) colorOptIndex = i;
      else if (/size|مقاس/i.test(name)) sizeOptIndex = i;
    });

    function optionValue(v, index) { return [v.option1, v.option2, v.option3][index]; }

    var colors = [];
    if (colorOptIndex > -1) {
      var seenColors = {};
      product.variants.forEach(function (v) {
        var val = optionValue(v, colorOptIndex);
        if (val && !seenColors[val]) {
          seenColors[val] = true;
          colors.push({ value: val, image: (v.featured_image && v.featured_image.src) || product.featured_image || (product.images && product.images[0]) });
        }
      });
    }
    var sizes = [];
    if (sizeOptIndex > -1) {
      var seenSizes = {};
      product.variants.forEach(function (v) {
        var val = optionValue(v, sizeOptIndex);
        if (val && !seenSizes[val]) { seenSizes[val] = true; sizes.push(val); }
      });
    }

    var state = { color: colors.length ? colors[0].value : null, size: null, qty: 1 };

    function findVariant() {
      return product.variants.find(function (v) {
        var colorOk = colorOptIndex === -1 || !state.color || optionValue(v, colorOptIndex) === state.color;
        var sizeOk = sizeOptIndex === -1 || !state.size || optionValue(v, sizeOptIndex) === state.size;
        return colorOk && sizeOk;
      }) || product.variants[0];
    }

    var mainImageSrc = (colors[0] && colors[0].image) || product.featured_image || (product.images && product.images[0]) || "";

    body.innerHTML =
      '<div class="donia-quickview-media"><img data-qv-image src="' + mainImageSrc + '" alt="' + product.title.replace(/"/g, "&quot;") + '"></div>' +
      '<div class="donia-quickview-info">' +
      '<h2 class="donia-quickview-title">' + product.title + "</h2>" +
      '<div class="donia-product-price-row" dir="ltr">' +
      '<span class="donia-price-num price-shine" data-qv-price></span>' +
      '<span class="donia-price-num donia-price-compare" data-qv-compare hidden></span>' +
      '<span class="donia-off-chip donia-price-num" data-qv-off hidden></span>' +
      "</div>" +
      (colors.length
        ? '<div class="donia-option-group"><span class="donia-option-label">اللون: <span data-qv-color-label></span></span><div class="donia-option-swatches">' +
          colors.map(function (c) {
            return '<button type="button" class="donia-swatch" data-qv-color="' + c.value + '" data-qv-color-image="' + c.image + '" aria-label="' + c.value + '"><img src="' + c.image + '" alt="" loading="lazy"></button>';
          }).join("") +
          "</div></div>"
        : "") +
      (sizes.length
        ? '<div class="donia-option-group"><span class="donia-option-label">المقاس: <span data-qv-size-label>اختاري المقاس</span></span><div class="donia-option-pills">' +
          sizes.map(function (s) { return '<button type="button" class="donia-size-pill" data-qv-size="' + s + '">' + s + "</button>"; }).join("") +
          "</div></div>"
        : "") +
      '<div class="donia-quantity-row"><span class="donia-option-label">الكمية</span><div class="donia-qty-picker"><button type="button" data-qv-qty="1" aria-label="+">+</button><span class="donia-price-num" data-qv-qty-value>1</span><button type="button" data-qv-qty="-1" aria-label="-">-</button></div></div>' +
      '<div class="donia-purchase-block">' +
      '<button type="button" class="cta-shake-fast donia-btn donia-btn-gold-outline" style="width:100%" data-qv-add>أضف إلى السلة</button>' +
      '<button type="button" class="cta-shake-fast donia-btn donia-btn-ink-vivid donia-btn-wide" style="width:100%" data-qv-buy><span class="gold-text-sharp">اشتر الآن</span></button>' +
      '<a href="' + product.url + '" class="donia-quickview-full-link">عرض التفاصيل الكاملة</a>' +
      "</div></div>";

    function render() {
      var variant = findVariant();
      body.querySelector("[data-qv-price]").textContent = formatMoney(variant.price);
      var compareEl = body.querySelector("[data-qv-compare]");
      var offEl = body.querySelector("[data-qv-off]");
      var off = 0;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        off = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        compareEl.hidden = false;
        compareEl.textContent = formatMoney(variant.compare_at_price);
      } else {
        compareEl.hidden = true;
      }
      if (off > 0) { offEl.hidden = false; offEl.textContent = "-" + off + "%"; } else { offEl.hidden = true; }

      body.querySelectorAll("[data-qv-color]").forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-qv-color") === state.color);
      });
      body.querySelectorAll("[data-qv-size]").forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-qv-size") === state.size);
      });
      var colorLabel = body.querySelector("[data-qv-color-label]");
      if (colorLabel) colorLabel.textContent = state.color || "";
      var sizeLabel = body.querySelector("[data-qv-size-label]");
      if (sizeLabel) sizeLabel.textContent = state.size || "اختاري المقاس";
      var qtyEl = body.querySelector("[data-qv-qty-value]");
      if (qtyEl) qtyEl.textContent = state.qty;
    }

    body.querySelectorAll("[data-qv-color]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.color = btn.getAttribute("data-qv-color");
        var img = body.querySelector("[data-qv-image]");
        if (img) img.src = btn.getAttribute("data-qv-color-image");
        render();
      });
    });
    body.querySelectorAll("[data-qv-size]").forEach(function (btn) {
      btn.addEventListener("click", function () { state.size = btn.getAttribute("data-qv-size"); render(); });
    });
    body.querySelectorAll("[data-qv-qty]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.qty = Math.max(1, state.qty + parseInt(btn.getAttribute("data-qv-qty"), 10));
        render();
      });
    });

    function validate() {
      if (colors.length && !state.color) { showToast("اختاري اللون أولاً", "error"); return false; }
      if (sizes.length && !state.size) { showToast("اختاري المقاس أولاً", "error"); return false; }
      return true;
    }

    var addBtn = body.querySelector("[data-qv-add]");
    var buyBtn = body.querySelector("[data-qv-buy]");
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        if (!validate()) return;
        var variant = findVariant();
        addToCart(variant.id, state.qty).then(function () {
          showToast("تمت الإضافة إلى الحقيبة");
          closeDrawer(document.getElementById("donia-quickview-modal"));
        });
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener("click", function () {
        if (!validate()) return;
        var variant = findVariant();
        addToCart(variant.id, state.qty).then(function () { window.location.href = "/checkout"; });
      });
    }

    render();
  }

  document.addEventListener("click", function (e) {
    var qtyBtn = e.target.closest("[data-cart-qty]");
    if (qtyBtn) {
      e.preventDefault();
      var line = qtyBtn.closest(".donia-cart-line");
      var current = parseInt(line.querySelector(".donia-price-num").textContent, 10) || 1;
      var delta = parseInt(qtyBtn.getAttribute("data-delta"), 10);
      changeCartLine(qtyBtn.getAttribute("data-cart-qty"), Math.max(0, current + delta));
      return;
    }
    var removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      e.preventDefault();
      changeCartLine(removeBtn.getAttribute("data-cart-remove"), 0);
      return;
    }
    var checkoutBtn = e.target.closest("[data-checkout]");
    if (checkoutBtn) {
      e.preventDefault();
      window.location.href = "/checkout";
      return;
    }
    var addBtn = e.target.closest("[data-add-to-cart]");
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute("data-add-to-cart");
      if (!variantId) return;
      var qtyInput = document.querySelector(addBtn.getAttribute("data-qty-source") || "[data-quantity-value]");
      var qty = qtyInput ? parseInt(qtyInput.textContent || qtyInput.value, 10) || 1 : 1;
      addBtn.disabled = true;
      addToCart(variantId, qty).then(function () {
        addBtn.disabled = false;
        if (addBtn.hasAttribute("data-buy-now")) {
          window.location.href = "/checkout";
        } else {
          showToast("تمت الإضافة إلى الحقيبة");
          openDrawer(document.getElementById("donia-cart-drawer"));
        }
      });
      return;
    }
    var quickViewBtn = e.target.closest("[data-quickview-open]");
    if (quickViewBtn) {
      e.preventDefault();
      openQuickView(quickViewBtn.getAttribute("data-quickview-open"));
    }
  });

  /* ---------------- Search drawer (predictive search) ---------------- */
  var searchInput = document.querySelector("[data-search-input]");
  var searchResults = document.getElementById("donia-search-results");
  var searchEmpty = document.getElementById("donia-search-empty");
  var searchTimer;

  if (searchInput) {
    searchInput.addEventListener("input", function () {
      clearTimeout(searchTimer);
      var term = searchInput.value.trim();
      searchTimer = setTimeout(function () { runSearch(term); }, 320);
    });
  }

  function runSearch(term) {
    if (!searchResults) return;
    if (term.length < 2) {
      searchResults.innerHTML = "";
      if (searchEmpty) { searchEmpty.hidden = false; searchEmpty.textContent = "اكتبي كلمة للبحث في مجموعات دنيا ستور."; }
      return;
    }
    if (searchEmpty) searchEmpty.hidden = true;
    searchResults.innerHTML = '<li class="donia-search-loading">جارِ البحث…</li>';
    fetch("/search/suggest.json?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,vendor")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) {
          searchResults.innerHTML = "";
          if (searchEmpty) { searchEmpty.hidden = false; searchEmpty.textContent = "لا توجد نتائج مطابقة — جرّبي كلمة أخرى."; }
          return;
        }
        searchResults.innerHTML = products.map(function (p) {
          return (
            '<li><a href="' + p.url + '" class="donia-search-result">' +
            '<img src="' + (p.image || "") + '" alt="" loading="lazy" />' +
            '<span><span class="donia-search-result-title">' + p.title + "</span>" +
            '<span class="donia-price-num donia-search-result-price">' + p.price + "</span></span>" +
            "</a></li>"
          );
        }).join("");
      });
  }

  /* ---------------- Header: announcement ticker + scroll shrink ---------------- */
  var ticker = document.querySelector("[data-announcement-ticker]");
  if (ticker) {
    var lines = Array.prototype.slice.call(ticker.querySelectorAll("[data-announcement-line]"));
    var idx = 0;
    if (lines.length > 1) {
      setInterval(function () {
        lines[idx].classList.remove("is-active");
        idx = (idx + 1) % lines.length;
        lines[idx].classList.add("is-active");
      }, 4200);
    }
  }

  /* Hero scroll-tilt parallax — mirrors Hero.tsx: rotateX up to 7deg, scale to
     1.08, translateY up to 40px as the hero scrolls out of view. */
  var heroEl = document.querySelector("[data-hero-tilt]");
  var heroLayer = heroEl && heroEl.querySelector("[data-hero-tilt-layer]");
  if (heroEl && heroLayer && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    var heroFrame = 0;
    var updateHeroTilt = function () {
      heroFrame = 0;
      var rect = heroEl.getBoundingClientRect();
      var progress = Math.min(Math.max(-rect.top / rect.height, 0), 1);
      heroLayer.style.transform =
        "translateY(" + (progress * 40) + "px) scale(" + (1 + progress * 0.08) + ") rotateX(" + (progress * 7) + "deg)";
    };
    updateHeroTilt();
    window.addEventListener("scroll", function () {
      if (!heroFrame) heroFrame = requestAnimationFrame(updateHeroTilt);
    }, { passive: true });
  }

  /* Service-features carousel — autoplay, pause on hover/focus/offscreen,
     RTL-aware swipe, keyboard arrows; mirrors the source's useCarousel hook. */
  document.querySelectorAll("[data-features-carousel]").forEach(function (root) {
    var track = root.querySelector("[data-features-track]");
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dotsWrap = root.parentElement.querySelector("[data-features-dots]");
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
    var count = slides.length;
    if (!track || count < 2) return;

    var index = 0, paused = false, visible = true, timer = null;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function render() {
      track.style.transform = "translateX(" + index * 100 + "%)";
      dots.forEach(function (dot, i) { dot.classList.toggle("is-active", i === index); });
    }
    function go(next) { index = ((next % count) + count) % count; render(); }
    function goNext() { go(index + 1); }
    function goPrev() { go(index - 1); }
    function pause() { paused = true; }
    function resume() { paused = false; }

    function tick() {
      if (reduced || paused || !visible) return;
      goNext();
    }
    if (!reduced) timer = setInterval(tick, 3600);

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0] ? entries[0].isIntersecting : true;
      }, { threshold: 0.15 }).observe(root);
    }

    root.addEventListener("mouseenter", pause);
    root.addEventListener("mouseleave", resume);
    root.addEventListener("focusin", pause);
    root.addEventListener("focusout", resume);

    var startPoint = null;
    root.addEventListener("pointerdown", function (e) { startPoint = { x: e.clientX, y: e.clientY }; pause(); });
    root.addEventListener("pointerup", function (e) {
      var s = startPoint;
      startPoint = null;
      setTimeout(resume, 2500);
      if (!s) return;
      var dx = e.clientX - s.x;
      if (Math.abs(dx) < 40 || Math.abs(e.clientY - s.y) > Math.abs(dx)) return;
      if (dx > 0) goPrev(); else goNext();
    });
    root.addEventListener("pointercancel", function () { startPoint = null; resume(); });

    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { e.preventDefault(); goNext(); }
      else if (e.key === "ArrowRight") { e.preventDefault(); goPrev(); }
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { go(i); });
    });

    render();
  });

  var headerBar = document.querySelector("[data-header-shrink]");
  if (headerBar) {
    window.addEventListener("scroll", function () {
      headerBar.classList.toggle("is-scrolled", window.scrollY > 40);
    }, { passive: true });
  }

  /* Mobile bottom nav: hide on scroll down, show on scroll up */
  var bottomNav = document.querySelector("[data-hide-on-scroll]");
  if (bottomNav) {
    var lastY = window.scrollY;
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      bottomNav.classList.toggle("is-hidden", y > lastY && y > 120);
      lastY = y;
    }, { passive: true });
  }

  /* ---------------- Reveal on scroll ---------------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute("data-revealed", "true");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.setAttribute("data-revealed", "true"); });
  }

  /* ---------------- Product page: variant matching ---------------- */
  document.querySelectorAll("[data-product-json]").forEach(function (script) {
    var wrap = script.closest("[data-product-root]");
    if (!wrap) return;
    var product;
    try { product = JSON.parse(script.textContent); } catch (e) { return; }

    var colorOptIndex = -1, sizeOptIndex = -1;
    (product.options_with_values || product.options || []).forEach(function (opt, i) {
      var name = typeof opt === "string" ? opt : opt.name;
      if (/color|لون/i.test(name)) colorOptIndex = i;
      else if (/size|مقاس/i.test(name)) sizeOptIndex = i;
    });

    var state = { color: null, size: null };
    var colorButtons = wrap.querySelectorAll("[data-color-option]");
    var sizeButtons = wrap.querySelectorAll("[data-size-option]");
    if (colorButtons.length) state.color = colorButtons[0].getAttribute("data-color-option");
    // size left unselected on purpose — must be chosen (matches source behaviour)

    function optionValue(variant, index) {
      return [variant.option1, variant.option2, variant.option3][index];
    }

    function findVariant() {
      return product.variants.find(function (v) {
        var colorOk = colorOptIndex === -1 || !state.color || optionValue(v, colorOptIndex) === state.color;
        var sizeOk = sizeOptIndex === -1 || !state.size || optionValue(v, sizeOptIndex) === state.size;
        return colorOk && sizeOk;
      }) || product.variants[0];
    }

    function render() {
      var variant = findVariant();
      var priceEl = wrap.querySelector("[data-current-price]");
      var compareEl = wrap.querySelector("[data-compare-price]");
      var offEl = wrap.querySelector("[data-off-chip]");
      var addBtn = wrap.querySelector("[data-add-to-cart]");
      var buyBtn = wrap.querySelector("[data-buy-now]");
      var stickyBtn = wrap.querySelector("[data-sticky-add]");

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var off = 0;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        off = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(variant.compare_at_price);
        } else compareEl.hidden = true;
      }
      if (offEl) {
        if (off > 0) { offEl.hidden = false; offEl.textContent = "-" + off + "%"; } else offEl.hidden = true;
      }

      var needsSize = sizeOptIndex > -1 && !state.size;
      var ready = variant.available && !needsSize;
      [addBtn, buyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.setAttribute("data-add-to-cart", ready ? variant.id : "");
        btn.disabled = !ready;
      });
      if (stickyBtn) {
        stickyBtn.setAttribute("data-add-to-cart", ready ? variant.id : "");
        stickyBtn.disabled = !ready;
        var stickyPrice = stickyBtn.querySelector("[data-sticky-price]");
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      }

      var mainImg = wrap.querySelector("[data-gallery-main] img");
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        mainImg.src = variant.featured_image.src;
      }

      colorButtons.forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-color-option") === state.color);
      });
      sizeButtons.forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-size-option") === state.size);
      });
      var sizeLabel = wrap.querySelector("[data-size-label]");
      if (sizeLabel) sizeLabel.textContent = state.size || "اختاري المقاس";
      var colorLabel = wrap.querySelector("[data-color-label]");
      if (colorLabel) colorLabel.textContent = state.color || "";
    }

    colorButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.color = btn.getAttribute("data-color-option");
        var idx = btn.getAttribute("data-image-index");
        if (idx !== null) {
          var thumb = wrap.querySelector('[data-thumb][data-index="' + idx + '"]');
          if (thumb) thumb.click();
        }
        render();
      });
    });
    sizeButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.size = btn.getAttribute("data-size-option");
        render();
      });
    });

    /* Gallery thumbnails */
    var mainWrap = wrap.querySelector("[data-gallery-main]");
    wrap.querySelectorAll("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        wrap.querySelectorAll("[data-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
        if (mainWrap) {
          var img = mainWrap.querySelector("img");
          var full = thumb.getAttribute("data-full") || thumb.querySelector("img").src;
          if (img) img.src = full;
        }
      });
    });

    /* Quantity picker — keeps every [data-quantity-value] in the product root
       (main block + sticky mobile bar) in sync with each other. */
    wrap.querySelectorAll("[data-quantity-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var valueEls = wrap.querySelectorAll("[data-quantity-value]");
        if (!valueEls.length) return;
        var current = parseInt(valueEls[0].textContent, 10) || 1;
        var delta = parseInt(btn.getAttribute("data-quantity-btn"), 10);
        var next = Math.max(1, current + delta);
        valueEls.forEach(function (el) { el.textContent = next; });
      });
    });

    /* Accordion tabs */
    wrap.querySelectorAll("[data-tab-trigger]").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var panel = document.getElementById(trigger.getAttribute("aria-controls"));
        var isOpen = trigger.getAttribute("aria-expanded") === "true";
        trigger.setAttribute("aria-expanded", String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });

    /* Zoom lightbox */
    var zoomBtn = wrap.querySelector("[data-zoom-open]");
    var zoomModal = document.getElementById("donia-zoom-modal");
    if (zoomBtn && zoomModal) {
      zoomBtn.addEventListener("click", function () {
        var img = mainWrap.querySelector("img");
        zoomModal.querySelector("img").src = img.src;
        zoomModal.classList.add("is-open");
      });
    }

    if (product.handle) pushRecentlyViewed(product.handle);

    render();
  });

  /* ---------------- Collection filters (client-side, matches source UX) ---------------- */
  var filterRoot = document.querySelector("[data-collection-filters]");
  if (filterRoot) {
    var grid = document.getElementById("donia-collection-grid");
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll("[data-product-card]")) : [];
    var fState = { sort: "featured", saleOnly: false, size: null };

    function applyFilters() {
      var visible = cards.filter(function (card) {
        var compareAt = parseFloat(card.getAttribute("data-compare-at") || "0");
        var price = parseFloat(card.getAttribute("data-price") || "0");
        if (fState.saleOnly && !(compareAt > price)) return false;
        if (fState.size) {
          var sizes = (card.getAttribute("data-sizes") || "").split("|");
          if (sizes.indexOf(fState.size) === -1) return false;
        }
        return true;
      });
      cards.forEach(function (card) { card.hidden = visible.indexOf(card) === -1; });

      visible.sort(function (a, b) {
        var pa = parseFloat(a.getAttribute("data-price") || "0");
        var pb = parseFloat(b.getAttribute("data-price") || "0");
        var ca = parseFloat(a.getAttribute("data-compare-at") || "0");
        var cb = parseFloat(b.getAttribute("data-compare-at") || "0");
        if (fState.sort === "price-asc") return pa - pb;
        if (fState.sort === "price-desc") return pb - pa;
        if (fState.sort === "discount") {
          var da = ca > pa ? 1 - pa / ca : 0;
          var db = cb > pb ? 1 - pb / cb : 0;
          return db - da;
        }
        return 0;
      });
      visible.forEach(function (card) { grid.appendChild(card); });

      var countEl = filterRoot.querySelector("[data-filter-count]");
      if (countEl) countEl.textContent = visible.length + " منتج";
    }

    filterRoot.querySelectorAll("[data-sort]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        fState.sort = btn.getAttribute("data-sort");
        filterRoot.querySelectorAll("[data-sort]").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        applyFilters();
      });
    });
    var saleBtn = filterRoot.querySelector("[data-sale-only]");
    if (saleBtn) {
      saleBtn.addEventListener("click", function () {
        fState.saleOnly = !fState.saleOnly;
        saleBtn.classList.toggle("is-active", fState.saleOnly);
        applyFilters();
      });
    }
    filterRoot.querySelectorAll("[data-size-filter]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var val = btn.getAttribute("data-size-filter");
        fState.size = fState.size === val ? null : val;
        filterRoot.querySelectorAll("[data-size-filter]").forEach(function (b) { b.classList.remove("is-active"); });
        if (fState.size) btn.classList.add("is-active");
        applyFilters();
      });
    }
    );
    applyFilters();
  }

  /* ---------------- Favorites / Recently viewed pages (fetch by handle) ---------------- */
  function renderProductCardsInto(container, handles) {
    if (!container) return;
    if (handles.length === 0) {
      container.innerHTML = "";
      var emptyState = container.getAttribute("data-empty-target");
      if (emptyState) {
        var el = document.getElementById(emptyState);
        if (el) el.hidden = false;
      }
      return;
    }
    container.innerHTML = '<p class="donia-loading-text">جارِ التحميل…</p>';
    Promise.all(
      handles.map(function (h) {
        return fetch("/products/" + h + ".js").then(function (r) { return (r.ok ? r.json() : null); }).catch(function () { return null; });
      })
    ).then(function (products) {
      products = products.filter(Boolean);
      if (products.length === 0) {
        container.innerHTML = '<p class="donia-loading-text">لا توجد منتجات لعرضها.</p>';
        return;
      }
      container.innerHTML = products.map(renderMiniProductCard).join("");
      updateFavoriteUI();
    });
  }

  function renderMiniProductCard(p) {
    var img = p.featured_image || (p.images && p.images[0]) || "";
    var off = 0;
    if (p.compare_at_price && p.compare_at_price > p.price) {
      off = Math.round(((p.compare_at_price - p.price) / p.compare_at_price) * 100);
    }
    return (
      '<article class="donia-product-card">' +
      '<a href="' + p.url + '" class="donia-product-card-media">' +
      '<img src="' + img + '" alt="' + p.title + '" loading="lazy" />' +
      (off > 0 ? '<span class="donia-sale-chip donia-badge">-' + off + "%</span>" : "") +
      "</a>" +
      '<button type="button" class="donia-fav-btn is-active" data-favorite-toggle="' + p.handle + '" aria-label="إزالة من المفضلة">♥</button>' +
      '<a href="' + p.url + '" class="donia-product-card-title">' + p.title + "</a>" +
      '<span class="donia-price-num price-shine donia-product-card-price">' + formatMoney(p.price) + "</span>" +
      "</article>"
    );
  }

  var favContainer = document.getElementById("donia-favorites-grid");
  if (favContainer) renderProductCardsInto(favContainer, getFavorites());
  document.addEventListener("donia:favorites-changed", function (e) {
    if (favContainer) renderProductCardsInto(favContainer, e.detail);
  });

  var rvContainer = document.getElementById("donia-recently-viewed-grid");
  if (rvContainer) {
    var exclude = rvContainer.getAttribute("data-exclude-handle");
    var handles = getRecentlyViewed().filter(function (h) { return h !== exclude; }).slice(0, 4);
    var rvSection = document.getElementById("donia-recently-viewed-section");
    if (handles.length === 0) {
      if (rvSection) rvSection.hidden = true;
    } else {
      if (rvSection) rvSection.hidden = false;
      renderProductCardsInto(rvContainer, handles);
    }
  }

  updateFavoriteUI();

  /* ---------------- Mobile menu ---------------- */
  var menuTrigger = document.querySelector("[data-open-mobile-menu]");
  var mobileMenu = document.getElementById("donia-mobile-menu");
  if (menuTrigger && mobileMenu) {
    menuTrigger.addEventListener("click", function () { openDrawer(mobileMenu); });
  }

  /* Scroll-to-top */
  var toTop = document.querySelector("[data-scroll-top]");
  if (toTop) toTop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
})();
